export default "__VITE_ASSET__BPEQgNUR__"